export function DateRangePicker({
  from,
  to,
  onChange,
}: {
  from: string; // YYYY-MM-DD, inclusive
  to: string; // YYYY-MM-DD, inclusive
  onChange: (from: string, to: string) => void;
}) {
  return (
    <div className="flex items-end gap-3">
      <div className="flex flex-col gap-1.5">
        <label htmlFor="date-from" className="label">From</label>
        <input
          id="date-from"
          type="date"
          className="select"
          value={from}
          max={to}
          onChange={(e) => e.target.value && onChange(e.target.value, to)}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor="date-to" className="label">To</label>
        <input
          id="date-to"
          type="date"
          className="select"
          value={to}
          min={from}
          onChange={(e) => e.target.value && onChange(from, e.target.value)}
        />
      </div>
    </div>
  );
}
